<template>
    <div class="action-item-wrap">
        <div class="header">
            <span class="delete" style="cursor: pointer" @click="handleDelete">
                <i class="el-icon-delete"></i>
                删除
            </span>
        </div>
        <el-row style="display: flex; align-items: center; justify-content: space-between;">
            <el-col :span="12">
                <div class="action-label">名称:</div>
                <el-input @change="handleNameChange" size="mini" v-model="value.name" placeholder="请输入名称" />
            </el-col>
            <el-col :span="12">
                <div class="action-label">类型:</div>
                <el-select :value="value.type" class="use-property" size="mini" placeholder="请选择类型"
                    @change="handlePropChange">
                    <el-option v-for="item in propOptions" :key="item.value" :label="item.label" size="mini"
                        :value="item.value"> </el-option>
                </el-select>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: '',
          type: ''
        }
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      propOptions: [
        {
          label: '文本',
          value: 'text'
        },
        {
          label: '图片',
          value: 'image'
        },
        {
          label: '语音',
          value: 'voice'
        },
        {
          label: '视频',
          value: 'video'
        },
        {
          label: '文件',
          value: 'file'
        },
        {
          label: 'Markdown',
          value: 'markdown'
        }
      ]
    }
  },
  methods: {
    handleNameChange (value) {
      this.value.name = value
      this.$emit('change', this.value)
    },
    handlePropChange (value) {
      this.value.type = value
      this.$emit('change', this.value)
    },
    handleDelete () {
      this.$emit('delete')
    }
  }
}
</script>
<style lang="less" scoped>
.action-item-wrap {
    background: #f3f6fa;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #303a51;
    line-height: 16px;
    font-weight: 400;
    padding: 9px 12px;
}

.header {
    // border-bottom: 1px solid #dcdfe6;
    margin-bottom: 8px;
    padding: 0 0 4px 0;
}

.delete {
    float: right;
    color: #a8adbd;
    font-weight: 400;

    &:hover {
        color: #2961ef;
    }
}

/deep/.el-col {
    display: flex;
}

/deep/.el-select {
    flex: 1;
}

.value-select {
    flex: 1;
}

.delete-button {
    height: 32px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.action-label {
    margin-right: 10px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    min-width: 30px;
    padding-left: 10px;
}
</style>
